// extracted by mini-css-extract-plugin
export default {"input":"TransactionInput_input__+H8mh","input_subtitle":"TransactionInput_input_subtitle__bdB5h","amount":"TransactionInput_amount__A+cda"};